module.exports = __webpack_public_path__ + "static/media/email.77032aab.svg";